import type { Icon } from '../HugeIcon/huge-icon';

export type SingleSelectListTagVariant = 'default' | 'collection';

export type SingleSelectListTag = {
  label: string;
  variant?: SingleSelectListTagVariant;
  tooltip?: string;
};

export type SingleSelectListItem = {
  id: string;
  label: string;
  color?: string;
  icon?: Icon;
  tags?: (string | SingleSelectListTag)[];
  groupLabel?: string;
};

export type SingleSelectListProps = {
  items: SingleSelectListItem[];
  selectedId?: string;
};

export type NormalizedSingleSelectListTag = Required<
  Pick<SingleSelectListTag, 'label' | 'variant'>
> &
  Pick<SingleSelectListTag, 'tooltip'>;

export const normalizeSingleSelectListTag = (
  tag: string | SingleSelectListTag,
): NormalizedSingleSelectListTag => {
  if (typeof tag === 'string') {
    return { label: tag, variant: 'default' };
  }

  return {
    label: tag.label,
    variant: tag.variant ?? 'default',
    tooltip: tag.tooltip,
  };
};

export const getSingleSelectListItemTags = (
  item: SingleSelectListItem,
): NormalizedSingleSelectListTag[] => {
  return (item.tags ?? []).map(normalizeSingleSelectListTag);
};
